import { encryptStorage } from 'src/Util'
import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'

const ProtectedRoute = ({ children }) => {
  const auth = encryptStorage.getItem('session-auth')
  if (!auth) {
    // user is not authenticated
    return <Navigate to="/login" />
  }
  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.object,
  redirectTo: PropTypes.string,
}
export default ProtectedRoute
